import { render, staticRenderFns } from "./partner-list.vue?vue&type=template&id=04379b0a&scoped=true&"
import script from "./partner-list.ts?vue&type=script&lang=ts&"
export * from "./partner-list.ts?vue&type=script&lang=ts&"
import style0 from "./partner-list.scss?vue&type=style&index=0&id=04379b0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04379b0a",
  null
  
)

export default component.exports